'use strict';
import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import BinfButton from '@/components/buttons/BinfButton.jsx';

import { Link, UserOptions } from '../index.jsx';
import { ProjectSearch } from '@/containers/ProjectSearch.jsx';
import headerlogo from '../../theme/svg/MyMetabolon-white-small.svg';
// import { Logger, Log } from '@/utils/Logger';
// import * as enums from '@/enums/Enums';
// import * as config from '@/config/env.config';
import './AppHeader.scss';
import { useLocation } from 'react-router';
import { useUserProfile } from '@/hooks/useUserProfile.js';
// import { getIdTokenFromLocalStorage } from '@/utils/auth0Token';
// const logger = new Logger();

export const AppHeader = (props) => {
	const location = useLocation();
	const [navIndex, setNavIndex] = useState(0);
	const [showUserOptions, setShowUserOptions] = useState(false);
	const { username, email, avatar } = useUserProfile();

	useEffect(() => {
		if (location.pathname.indexOf("resources") != -1) {
			setNavIndex(1);
		}
	}, [location.pathname])

	const handleClick = useCallback((e) => {
		e.stopPropagation()
		setShowUserOptions((prev) => !prev)
	}, [showUserOptions])

	const handleOutsideClick = useCallback((e) => {
		setShowUserOptions(false)
	}, [])

	useEffect(() => {
		if (showUserOptions) document.addEventListener('click', handleOutsideClick, false);
		else document.removeEventListener('click', handleOutsideClick, false);
		return () => {
			document.removeEventListener('click', handleOutsideClick, false);
		}
	}, [showUserOptions]);

	// Surveyor link is temporarily hidden and will be restored.
	// const launchSurveyor = useCallback(() => {
	// 	let logFilterChange = new Log();
	// 	logFilterChange.SetLevel(enums.AppInsightLogLevel.EVENT);
	// 	logFilterChange.SetName('PageView_Surveyor');
	// 	logFilterChange.AddProperty('view', "Surveyor");
	// 	logger.doLog(logFilterChange);
	//
	// 	const surveyorToken = getIdTokenFromLocalStorage();
	// 	let surveyorURL = config.URL_SURVEYOR_SSO + '?token=' + (surveyorToken || '');
	// 	window.open(surveyorURL);
	// }, []);

	// Generate initials from username or email
	const getInitials = useCallback(() => {
		if (!username && !email) return 'U';
		
		const nameToUse = username || email?.split('@')[0] || '';
		if (!nameToUse) return 'U';
		
		// Split by space or period and get first letter of each part
		const parts = nameToUse.trim().split(/[\s.]+/);
		if (parts.length >= 2) {
			// First letter of first name + first letter of last name
			return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
		}
		// Single name - use first two letters
		return nameToUse.substring(0, 2).toUpperCase();
	}, [username, email]);

	return (
		<div className="app-header">
			<div className="main-nav">
				<Link className="logo-container tertiary alt2" to="/home">
					<img src={headerlogo} alt="logo" />
				</Link>
			</div>
			<div className="sub-nav">
				<BinfButton alt2={true} color="white" />
				{/* Surveyor link is temporarily hidden and will be restored.
				<div style={{ color: 'white', top: '-1px', paddingTop: '3px', paddingRight: '10px', margin: '0px', cursor: 'pointer' }} onClick={launchSurveyor} className=" primary normal text-tertiary launchSurveyor">Surveyor&#8482;</div>
				*/}

				<div className="search" style={{ zIndex: '10' }}>
					<ProjectSearch id="header-search" searchDelay={true} dataModel={'projects'} iconColor={'white'} hintText={'Jump to...'} showResults={true} />
				</div>
				<div className="UserOptions">
					<Avatar 
						onClick={handleClick} 
						sx={{ 
							width: 30, 
							height: 30, 
							backgroundColor: avatar ? 'transparent' : '#ccc',
							cursor: 'pointer',
							fontSize: '12px',
							fontWeight: 'bold'
						}} 
						src={avatar || undefined}
						alt={username || email || 'User'}
					>
						{!avatar && getInitials()}
					</Avatar>
					<UserOptions {...props} visible={showUserOptions} username={username} email={email} />
				</div>
			</div>

		</div>
	);
}

export default withRouter(AppHeader);